<script lang="ts">
	import type { PageProps } from "./$types";
	import { PrivacyPolicy } from "#lib/web-ui/blocks/index.js";

	let { data }: PageProps = $props();
	const { contactInfo } = data;
</script>

<svelte:head>
	<title>Privacy Policy | Fergmar Capital</title>
	<meta
		name="description"
		content="Review our privacy policy to understand how Fergmar Capital protects your personal information and data."
	/>
	<meta name="viewport" content="width=device-width, initial-scale=1.0" />
	<meta property="og:title" content="Privacy Policy | Fergmar Capital" />
	<meta property="og:site_name" content="Fergmar Capital" />
	<meta
		property="og:description"
		content="Review our privacy policy to understand how Fergmar Capital protects your personal information and data."
	/>
</svelte:head>

<PrivacyPolicy
	entityName="Fergmar Capital, LLC"
	domain="fergmarcapital.com"
	email={contactInfo.email}
	contactUrl="/contact"
	address={contactInfo.address}
	lastUpdated="May 12th, 2026"
/>
